import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import {  MessageService } from 'primeng/api';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import { ToastModule } from 'primeng/toast';

import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationsService } from './notifications/notifications.service';
import { SimNaoPipe } from './pipes/sim-nao.pipe';
import { DateFormatPipe } from './pipes/date-pt.pipe';



@NgModule({
  imports: [ToastModule, MessagesModule,MessageModule,CommonModule],
  declarations: [
    NotificationsComponent     
     ],
  providers: [
    MessageService 
  ],
  exports: [
    NotificationsComponent
  ]

})



export class SharedModule {
  
}
